// extracted by mini-css-extract-plugin
module.exports = {"otherPlace":"GeoInformer_otherPlace__oDQ9b"};